import {ArrUtil, Util} from 'yougile-util'
import {Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {canShowTask} from './permissions'

// отображаем недоступные, кроме реально удаленных
export const getAllMirroredHubs = (
  task: Hub,
  sorted = true
): Hub[] | undefined => {
  const mirroredTasks = task?.data?.mirrors
  if (!mirroredTasks) {
    return undefined
  }

  const box = Sync.get(task)
  const unfilteredHubs = mirroredTasks.map(taskId => box.getHub(taskId))
  const hubs = ArrUtil.filterUndefined(unfilteredHubs)

  const filteredHubs = hubs.filter(h => {
    const hasPermissions = canShowTask(h)
    if (hasPermissions) {
      return !h.deleted
    }

    return h.properties['del'] !== 'yes'
  })

  if (!sorted) {
    return filteredHubs
  }

  return filteredHubs.sort((a, b) => {
    const aUUID = Number(Util.isUUID(a.title))
    const bUUID = Number(Util.isUUID(b.title))

    return aUUID - bUUID
  })
}
